import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createClassCertificate, editClassCertificate,
seeListTypesCertificates, seeListClassCertificate,
deleteClassCertificate } from '../../actions/certificationActions'
import { Translate } from '../../../language';
import { UseComponentVisible } from '../../../containers/UseComponentVisible'
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ClassCertificateAdmin = ({ createClassCertificate, seeListTypesCertificates, history, editClassCertificate, isLoadingListTypesCertificates, listTypesCertifications, listClassCertifications, isLoadingListClassCertificates, deleteClassCertificate, seeListClassCertificate }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
             
            seeListClassCertificate()
            seeListTypesCertificates()
        })
        
    },[])

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [typeOfCertificate, setTypeOfCertificate] = useState('')
    const [codeTypeOfCertificate, setCodeTypeOfCertificate] = useState('')
    const [name, setName] = useState('')
    const [price, setPrice] = useState('')
    const [score, setScore] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    console.log()

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            if (score !== '' && typeOfCertificate !== '' && name !== '' && price !== '') {
                setValidate(true)
            }
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));

            if (score !== '' && typeOfCertificate !== '' && name !== '' && price !== '') {
                setValidate(true)
            }
        }

    }

    const isFocused = (e) => {
        const { name } = e.target;
        if (score !== '' && typeOfCertificate !== '' && name !== '' && price !== '') {
            setValidate(true)
        }
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nueva'} clase de certificado`}</div>
                <div className="container-inputs-new-mark">
                    <div className="parent-width relative" ref={ref}>
                        <div
                            className="parent-width"
                            onClick={() =>
                                setIsComponentVisible(true)
                            }
                        >
                            <div className="text-input-admin">
                                {'Tipo de certificado:'}
                            </div>
                            <input
                                className='inputs-admin'
                                name="typeOfCertificate"
                                type="text"
                                value={typeOfCertificate}
                                onChange={(e) => {
                                    setTypeOfCertificate(e.target.value)
                                }}
                                autoComplete="off"

                            />
                        </div>
                        {isComponentVisible &&
                            <div className='scroll-menu modal-search-bar-economic-activities'>
                                <div className="modal-results-search-bar">
                                    <div>
                                        {isLoadingListTypesCertificates ? <div></div> :
                                            listTypesCertifications.map((certificate, index) => (
                                                <div onClick={() => {
                                                    setTypeOfCertificate(certificate.name)
                                                    setCodeTypeOfCertificate(certificate._id)
                                                    setIsComponentVisible(false)
                                                }} className="mb-2">
                                                    {certificate.codeType} {certificate.name}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="text-input-admin">
                        {'Puntaje:'}
                    </div>
                    <input className='inputs-admin'
                        name="score"
                        type="number"
                        value={score}
                        min="0"
                        pattern="^[0-9]+"
                        onKeyUp={e => isEmpty(e)}
                        onBlur={e => isEmpty(e)}
                        onChange={(e) => {
                            setScore(e.target.value.trimStart())
                            if (score !== '' && typeOfCertificate !== '' && name !== '' && price !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.score}</div>

                    <div className="text-input-admin">
                        {'Precio:'}
                    </div>
                    <input className='inputs-admin'
                        name="price"
                        type="number"
                        value={price}
                        min="0"
                        onKeyUp={e => isEmpty(e)}
                        onBlur={e => isEmpty(e)}
                        onChange={(e) => {
                            setPrice(e.target.value.trimStart())
                            if (score !== '' && typeOfCertificate !== '' && name !== '' && price !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.price}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {

                                setScore('')
                                setTypeOfCertificate('')
                                setPrice('')
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin  btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editClassCertificate({ typeID: codeTypeOfCertificate.trim(), scoreValue: score, id: idEdit, name: typeOfCertificate, price:price }, indexEdit)
                                    setScore('')
                                    setPrice('')
                                    setTypeOfCertificate('')
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        : <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin  btn-create-edit  ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createClassCertificate({ typeID: codeTypeOfCertificate.trim(), scoreValue: score, price:price}, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>


                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Certificados existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListClassCertificates ? <div>Cargando...</div> :
                        listClassCertifications.map((classCertificate, index) => (
                            <div key={classCertificate._id} className="card-admin">
                                <div className="tittle-card-admin">{classCertificate.name}</div>
                                <div className="text-content-card">{classCertificate.scoreValue}</div>
                                <div className="text-content-card">{classCertificate.price}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setScore(classCertificate.scoreValue)
                                        setTypeOfCertificate(classCertificate.name)
                                        setCodeTypeOfCertificate(classCertificate.typeID)
                                        setPrice(classCertificate.price)
                                        setIdEdit(classCertificate._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteClassCertificate(classCertificate._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListClassCertificates: state.certificationAdmin.isLoadingListClassCertificates,
        listClassCertifications: state.certificationAdmin.listClassCertifications,
        isLoadingListTypesCertificates: state.certificationAdmin.isLoadingListTypesCertificates,
        listTypesCertifications: state.certificationAdmin.listTypesCertifications
    }
}


export default connect(mapStateToProps, { createClassCertificate, seeListTypesCertificates, editClassCertificate, seeListClassCertificate, deleteClassCertificate })(ClassCertificateAdmin)